import api from 'services/api';
import { enforce, runSchema } from 'validation';

import { zoneSchema, type SaveZone, type Zone } from './postZone';

/**
 * PUT `/zones/:name` — update the zone identified by `originalName` (its
 * pre-edit name). The body's `name` is sent as the wire's `new_name` (a rename),
 * so callers pass the same `SaveZone` they'd give `postZone`. Returns the updated
 * zone (validated against the shared `zoneSchema` — same `getZoneDetails` shape
 * as create). Throws on HTTP error or structural validation failure.
 */
export const putZone = async (originalName: string, save: SaveZone): Promise<Zone> => {
  const res = await api.put(`/zones/${encodeURIComponent(originalName)}`, {
    new_name: save.name,
    description: save.description,
    retention_policies: save.retention_policies,
  });
  const r = runSchema(zoneSchema, res.data, 'putZone');
  if (!r.ok) {
    throw new Error('putZone: response failed validation');
  }
  return enforce(r.value, r.warnings, ['zone_id']);
};
